import { render, staticRenderFns } from "./TagEditorModal.vue?vue&type=template&id=1907c1ae&scoped=true"
import script from "./TagEditorModal.vue?vue&type=script&lang=js"
export * from "./TagEditorModal.vue?vue&type=script&lang=js"
import style0 from "./TagEditorModal.vue?vue&type=style&index=0&id=1907c1ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907c1ae",
  null
  
)

export default component.exports